// extracted by mini-css-extract-plugin
export default {"scrollContainer":"styles_scrollContainer__gFn-K","scrollContainerWrapper":"styles_scrollContainerWrapper__ZHeld","arrowButton":"styles_arrowButton__DGUZs"};